import { REQUEST_RESULT_STRUCTURE } from '../../../constants/api';

export class DocumentTypeExtractionFieldApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentTypeExtractionFieldByDocumentTypeId({ typeId }) {
    return this.#http.get(
      `/api/document-types/${typeId}/extraction-settings/document-extraction-fields`,
      {
        params: {
          resultStructure: REQUEST_RESULT_STRUCTURE.FLAT_VALUES,
        },
      },
    );
  }

  async createDocumentTypeExtractionField(body) {
    return this.#http.post(
      `/api/document-types/${body.typeId}/extraction-settings/document-extraction-fields`,
      body,
    );
  }

  async editDocumentTypeExtractionField(body) {
    return this.#http.put(
      `/api/document-types/${body.typeId}/extraction-settings/document-extraction-fields/${body.extractionFieldId}`,
      body,
    );
  }

  async deleteDocumentTypeExtractionField({ extractionFieldId, typeId }) {
    return this.#http.delete(
      `/api/document-types/${typeId}/extraction-settings/document-extraction-fields/${extractionFieldId}`,
    );
  }

  async reorderDocumentTypeExtractionField(body) {
    return this.#http.put(
      `/api/document-types/${body.typeId}/extraction-settings/document-extraction-fields`,
      body,
    );
  }

  async getDocumentTypeExtractionFieldByDocumentTypeExtractionFieldId({
    typeId,
    extractionFieldId,
  }) {
    return this.#http.get(
      `/api/document-types/${typeId}/extraction-settings/document-extraction-fields/${extractionFieldId}`,
    );
  }
}
